


















import Element from '../../mixins/element';
import { Component } from 'vue-property-decorator';

import payment from 'payment';

@Component
export default class Cvc extends Element {
    public toMount() {
        this.onLoading(false);
        // tslint:disable-next-line
        this.$parent.$on('CVCForceInput', (data: string) => {
            this.input.value = data;
            (this.$refs.input as any).value = data;
            // tslint:disable-next-line
            (this.$refs.input as any).dispatchEvent(new CustomEvent('input', {}));
        });

        (this.$refs.input as any).onpaste = (e) => {
            this.$once('serialized', () => {
                if (new RegExp(/^[0-9]*$/g).test(this.input.value.replace(/\s+/g, ''))) {
                    const value = this.input.value.substr(0, 4);
                    this.input = {
                        value,
                    };
                } else {
                    this.toClear();
                }
            });
        };
        // here work as usual
        payment.formatCardCVC((this.$refs as any).input);
    }

    public toDestroy(): void {
        // destroyed
    }

    public toValidate(): boolean {
        return payment.fns.validateCardCVC(this.input.value);
    }

    public toClear(): void {
        this.input = {
          value: '',
        };
    }

    public toFocus(): void {
        (this.$refs as any).input.focus();
    }

    public toBlur(): void {
        (this.$refs as any).input.blur();
    }
}
